import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import i18n, { _get_i18Lang } from '../../i18n';
import AboutService from "../../Services/OnePageServices";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { IconButton, Typography } from '@mui/material';
import { HeaderBox } from './MobileBookPage';

const MobilePromotionHindi = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [promotionList, setPromotionList] = useState<any[]>([]);
    const [showName, setShowName] = useState('');

    useEffect(() => {
        AboutService.getPromotionPageData(_get_i18Lang()).then((result: any) => {
            if (result?.result?.length > 0) {
                // Filter only Hindi promotions
                const hindiPromotions = result.result.filter((item: any) =>
                    item.name?.toLowerCase().includes("hindi") || item.name?.includes("हिंदी")
                );
                setPromotionList(hindiPromotions);
                if (hindiPromotions.length > 0) {
                    setShowName(hindiPromotions[0].name); // Pehle promotion ka naam
                }
            }
        });
    }, [i18n.language]);

    return (
        <>
            {/* Header */}
            <HeaderBox>
                <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                    <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                </IconButton>
                <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                    <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                </IconButton>
                <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                    {t("shrihari_tr")}
                </Typography>
                <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                    {showName}
                </Typography>
            </HeaderBox>

            {/* Content */}
            <div
                style={{
                    position: 'relative',
                    height: 'calc(100vh - 90px - 56px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '50%',
                    marginBottom: '56px'
                }}
            >
                {promotionList.length > 0 ? (
                    promotionList.map((item, index) => (
                        item.promotionPath && (
                            <div
                                key={index}
                                style={{
                                    width: '100%',
                                    maxWidth: 600,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    marginBottom: 16,
                                }}
                                onClick={() => {
                                    navigate('/pamphletHindi');
                                }}
                            >
                                <img
                                    src={item.promotionPath}
                                    alt={item.name}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: 8,
                                    }}
                                />
                            </div>
                        )
                    ))
                ) : (
                    <p>{t('no_hindi_promotions_found')}</p>
                )}
            </div>

            {/* Footer */}
            {/* <div style={{
                width: "100%",
                backgroundColor: "#f97316",
                padding: 18,
                position: 'fixed',
                bottom: 0
            }} /> */}
        </>
    );
};

export default MobilePromotionHindi;
